import { generateName } from "@common/Common";
import { ExpenseClassification } from "@Quest/Costs/types";

export class ResourceEditorViewModel
{
    opened: boolean = false;

    modalTitle: string | null = null;
    confirmButtonLabel: string | null = null;
    costPerUnitVisible: boolean | null = null;

    id: string | null = null;
    name: string | null = null;
    unit: string | null = null;
    costPerUnit: number | null = null;
    classification: string | null = null;


    showCreator()
    {
        this.id = null;
        this.name = generateName('Resource');
        this.unit = "FTE";
        this.costPerUnit = null;
        this.classification = ExpenseClassification.OpEx;

        this.modalTitle = "New resource";
        this.confirmButtonLabel = "Create";
        this.costPerUnitVisible = true;

        this.opened = true;
    }

    showEditor(id: string, name: string, unit: string, classification: string)
    {
        this.id = id;
        this.name = name;
        this.unit = unit;
        this.costPerUnit = null;
        this.classification = classification;

        this.modalTitle = "Edit resource";
        this.confirmButtonLabel = "Update";
        this.costPerUnitVisible = false;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.id = null;
        this.name = null;
        this.unit = null;
        this.costPerUnit = null;
        this.classification = null;

        this.modalTitle = null;
        this.confirmButtonLabel = null;
        this.costPerUnitVisible = null;
    }
}

export class ResourceEditorFormSubmitEventPayload
{
    id: string | null;
    name: string;
    unit: string | null;
    classification: string;
    costPerUnit: number | null;

    constructor(id: string | null, name: string, unit: string | null, classification: string, costPerUnit: number | null)
    {
        this.id = id;
        this.name = name;
        this.unit = unit;
        this.classification = classification;
        this.costPerUnit = costPerUnit;
    }
}